// extracted by mini-css-extract-plugin
export default {"item_wrapper":"product-posts-form_item_wrapper__v-xHy","items_container":"product-posts-form_items_container__64qbS"};